import {Image} from '@/product/types';
import {colorStyleMap} from '@/utilities/color-style-map';
import classNames from 'classnames';
import {ComponentChildren} from 'preact';

export type SelectorIconButtonProps = {
  children: ComponentChildren;
  color?: string;
  dataTestId?: string;
  icon?: Image;
  onClick?: () => void | Promise<void>;
  selected: boolean;
};

export default function SelectorIconButton({
  color = 'light-breeze',
  icon,
  children,
  onClick,
  selected,
  dataTestId = '',
}: SelectorIconButtonProps) {
  const borderColor = colorStyleMap.get(color)?.border ?? 'border-light-breeze';
  const backgroundColor =
    colorStyleMap.get(color)?.backgroundOpacity12 ?? 'bg-light-breeze/[.12]';

  return (
    <button
      onClick={onClick}
      data-testId={dataTestId}
      className={classNames(
        'rounded-full px-3 pb-2 pt-1 text-sm tracking-normal transition-all duration-150 ease-in-out xs:text-base',
        {
          'border border-deep-ocean-blue/70': !selected,
          [`border-2 ${borderColor} ${backgroundColor}`]: selected,
        }
      )}
    >
      {icon && (
        <img
          src={icon.url}
          alt={icon.alt}
          className="mr-1.5 inline size-4.5 align-middle"
        />
      )}
      {children}
    </button>
  );
}
